import HeroSection from './components/HeroSection';
import Navbar from './components/Navbar';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryButtons from './components/CategoryButtons';
import BenefitsSection from './components/BenefitsSection';
import SeoContent from './components/SeoContent';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />

      <div className="w-full py-6 px-4 md:px-6 -mt-10 relative z-20">
        <CategoryDropdown />
      </div>

      <CategoryButtons />

      <BenefitsSection />

      <SeoContent />

      <section className="w-full py-10 md:py-14 px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-accent-50/50 border border-accent-200/50 rounded-2xl p-8 md:p-10">
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-3">
              Explore Our Complete Guide Library
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-lg mx-auto">
              Dive into our in-depth guides covering everything from beginner basics to advanced shipping strategies.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <a
                href="/what-is-superbuy-spreadsheet/"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-6 py-2.5 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer text-sm"
              >
                <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
                Beginner Guide
              </a>
              <a
                href="/how-to-use-superbuy-spreadsheet/"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white font-semibold px-6 py-2.5 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer text-sm"
              >
                <i className="ri-guide-line w-4 h-4 flex items-center justify-center"></i>
                How to Use
              </a>
              <a
                href="/is-superbuy-spreadsheet-safe/"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-secondary-500 hover:bg-secondary-600 text-white font-semibold px-6 py-2.5 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer text-sm"
              >
                <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center"></i>
                Safety Guide
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-foreground-800 hover:bg-foreground-900 text-white font-semibold px-6 py-2.5 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer text-sm"
              >
                <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
                Visit Main Store
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}